
    <!--
 * 竖版-首页
 * @LastEditTime: Tue Dec 17 2024 15:43:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_QXLF22"  :class="[`normal`,`u_c_QXLF22`]" ><div id="u_c_H66R28"  :class="[`normal`,`u_c_H66R28`]" @click="u_c_H66R28_event_O1F141($event)"><div id="u_c_RNJC316"  v-show="compData.showRulePopup || pageData.previewPopup == 'info' || pageData.infoPopupState" :class="[`normal popup`,`u_c_RNJC316`]" @click="u_c_RNJC316_event_TETB35($event)"><div id="u_c_CW0J317"  :class="[`normal popup-content-big`,`u_c_CW0J317`]" @click="u_c_CW0J317_event_U82518($event)"><div id="u_c_GLI0318"  :class="[`normal popup-title popup-title-color`,`u_c_GLI0318`]" >{{`${ langData.infoBtn }`}}</div><div id="u_c_KANB320"  v-html="compData.infoContent || langData.ruleDetail" :class="[`normal txt-size txt-color`,`u_c_KANB320`]" ></div><a id="u_c_CU7D321" href="javascript:;" :class="[`normal popup-close`,`u_c_CU7D321`]" @click="u_c_CU7D321_event_DMX517($event)"></a></div></div>{{langData.infoBtn}}</div><div id="u_c_9GJF30"  :class="[`normal btn-bg btn-text`,`u_c_9GJF30`]" @click="u_c_9GJF30_event_5ZWY20($event)">{{langData.myPackage}}</div><div id="u_c_4Z6O38"  :class="[`normal btn-bg btn-text`,`u_c_4Z6O38`]" @click="u_c_4Z6O38_event_YVD624($event)">{{langData.refresh}}</div><div id="u_c_1NR525"  :class="[`normal`,`u_c_1NR525`]" ></div><h1 id="u_c_I7WN40"  :class="[`normal`,`u_c_I7WN40`]" ><div id="u_c_DNI241"  v-html="compData.title || langData.mainTitle" :style="`text-shadow:0 0 10px #1b1b1b`" :class="[`normal`,`u_c_DNI241`]" ></div><div id="u_c_KL7K42"  v-html="compData.title || langData.mainTitle" :style="`background-image:linear-gradient(to bottom, ${ pageData.mainTitleColorUp },${ pageData.mainTitleColorUp }, ${ pageData.mainTitleColorDown },${ pageData.mainTitleColorDown })`" :class="[`normal`,`u_c_KL7K42`]" ></div></h1><div id="u_c_VYPR27"  :class="[`normal`,`u_c_VYPR27`]" ><div id="u_c_1KC128"  v-html="compData.eventTime" :class="[`normal main-color`,`u_c_1KC128`]" ></div></div><div id="u_c_40PV29"  :class="[`normal main-color`,`u_c_40PV29`]" ><div id="u_c_YF2K30"  v-show="!pageData.isLogin" :class="[`normal login-box`,`u_c_YF2K30`]" ><div id="u_c_M12A31"  :class="[`normal txt`,`u_c_M12A31`]" >{{`${ langData.pleaseLogin }`}}</div><a id="u_c_LKGL33" href="javascript:;" :class="[`normal txt btn main-color`,`u_c_LKGL33`]" @click="u_c_LKGL33_event_Q72S64($event)">{{`[${ langData.login }]`}}</a></div><div id="u_c_L32Y35"  v-show="pageData.isLogin" :class="[`normal login-box`,`u_c_L32Y35`]" ><div id="u_c_1DP336"  v-show="pageData.isBind" :class="[`normal txt btn`,`u_c_1DP336`]" >{{`${ pageData.serverName }-${ pageData.roleName }`}}</div><div id="u_c_P9TD38"  :class="[`normal main-color`,`u_c_P9TD38`]" ><a id="u_c_VH2A39" href="javascript:;" v-show="!pageData.isBind" :class="[`normal txt btn main-color`,`u_c_VH2A39`]" @click="u_c_VH2A39_event_Z75334($event)">{{`[${ langData.bindTitle }]`}}</a><a id="u_c_M24U41" href="javascript:;" v-show="pageData.isBind && pageData.canReBind" :class="[`normal txt btn main-color`,`u_c_M24U41`]" @click="u_c_M24U41_event_Z75334($event)">{{`[${ langData.changRole }]`}}</a><a id="u_c_4IL543" href="javascript:;" v-if="false" :class="[`normal txt btn main-color`,`u_c_4IL543`]" @click="u_c_4IL543_event_4DJR33($event)">{{`[${ langData.myPackage }]`}}</a><a id="u_c_4CEU45" href="javascript:;" :class="[`normal txt btn main-color`,`u_c_4CEU45`]" @click="u_c_4CEU45_event_Q72S64($event)">{{`[${ langData.logout }]`}}</a></div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"eventTime":`活动时间：2024.3.15-2024.4.15`,"canChangeRole":true,"title":`组队邀请`,"infoContent":`活动时间：                        
 2023年12月19日 0:00～2024年1月18日 23:59 （UTC）                        
                        
 一、活动参与资格限制                        
 1.邀请发起人参与条件：HQ等级≥10；                        
 2.被邀请玩家满足以下任意一个条件均可参与：                        
 （1）HQ等级≥10，且连续14天未登录游戏；                        
 （2）活动时间开始后，新注册的账号                        
 注意：在以下说明中，邀请发起人简称为[邀请人]，被邀请玩家简称为[受邀人]                        
                         
 二、邀请说明                        
 1.活动期间，指挥官可进入活动页面，邀请符合条件的玩家完成活动任务，获取任务经验值，参与抽奖；                        
 2.受邀人在完成受邀人任务后，其邀请人可与受邀人获取同等任务经验值；                        
 3.每个玩家可同时作为邀请人和受邀人参与活动；不允许玩家自己邀请自己；
        4.邀请人活动期问内可邀请多位玩家，人数上限：20；
        5.受邀人只可以绑定一个邀请码，且绑定完成后无法更改，即每位受邀人仅能与1位邀请人绑定邀请关系；                                               
                        
 三、活动任务：具体任务设置请见页面展示               
 · 邀请任务（针对邀请人设置，完成任务后，邀请人可获取任务经验值）                        
 · 活跃任务（针对受邀人设置，受邀人完成任务后，邀请人可与受邀人获取同等任务经验值）
注意：受邀人首次绑定经验值，邀请人不可获得                                                       
 · 储值任务（针对受邀人设置，受邀人完成任务后，邀请人可与受邀人获取同等任务经验值）       

四、抽奖说明
1.消耗经验值可进行抽奖，每次抽奖消耗经验值以页面展示为准；
2.活动经验值请在活动期间使用完毕，未使用的经验值将在本次活动结束后清零；           
                         
 注意事项：                   
 1.禁止通过自行创建多个账号的形式参与活动，刷取奖励                        
 2.抽取到实物奖励的指挥官，需要在活动结束后的14天内通过游戏内客服或官方社区联系官方填写中奖信息，逾期未填写中奖信息的指挥官将被视为放弃奖励；                                           
                        
 本活动的最终解释权由《末日喧嚣》官方运营团队所有`,"showRulePopup":false},"zh-CN":{"eventTime":`活动时间：2024年10月16日 0:00～2024年10月29日 23:59 UTC`,"canChangeRole":true,"title":`恐怖游乐园`,"infoContent":``,"showRulePopup":false},"zh-TW":{"eventTime":`活動時間：2024年10月16日 0:00-2024年10月29日 23:59（UTC）`,"canChangeRole":true,"title":`恐怖遊樂園`,"infoContent":``,"showRulePopup":false},"en-US":{"eventTime":`Event Duration: October 16, 2024, 00:00 - October 29, 2024, 23:59 (UTC)`,"canChangeRole":true,"title":`The Park of Puppets`,"infoContent":``,"showRulePopup":false},"ja-JP":{"eventTime":`イベント期間：2024年10月16日 0:00~2024年10月29日 23:59（UTC）`,"canChangeRole":true,"title":`恐怖の遊園地`,"infoContent":``,"showRulePopup":false},"ko-KR":{"eventTime":`이벤트 기간: 2024년 10월 16일 00:00 ~ 2024년 10월 29일 23:59 (UTC)`,"canChangeRole":true,"title":`공포의 놀이공원`,"infoContent":``,"showRulePopup":false},"th-TH":{"eventTime":`เวลากิจกรรม : วันที่ 16 ตุลาคม 2024 เวลา 00:00 น. - วันที่ 29 ตุลาคม 2024 เวลา 23:59 น.(UTC)`,"canChangeRole":true,"title":`สวนสนุกน่ากลัว`,"infoContent":``,"showRulePopup":false},"vi-VN":{"eventTime":`Thời gian HĐ: 0:00 16/10/2024-23:59 29/10/2024 (UTC)`,"canChangeRole":true,"title":`Công Viên Kinh Dị`,"infoContent":``,"showRulePopup":false},"de-DE":{"eventTime":`Eventdauer: 16. Oktober 2024, 00:00 Uhr - 29. Oktober 2024, 23:59 Uhr (UTC)`,"canChangeRole":true,"title":`Park der Puppen`,"infoContent":``,"showRulePopup":false},"fr-FR":{"eventTime":`Durée de l'Événement : 16 Octobre, 2024 00h00 - 29 Octobre, 2024 23h59 (UTC)`,"canChangeRole":true,"title":`Parc des Marionnettes`,"infoContent":``,"showRulePopup":false},"ru-RU":{"eventTime":`Время события: 16 октября 2024, 00:00 - 29 октября 2024, 23:59 (UTC)`,"canChangeRole":true,"title":`Кукольный парк`,"infoContent":``,"showRulePopup":false},"es-ES":{"eventTime":`Duración del evento: 16 de octubre, 2024, 00:00 - 29 de octubre, 2024, 23:59 (UTC)`,"canChangeRole":true,"title":`Parque de las marionetas`,"infoContent":``,"showRulePopup":false},"pt-PT":{"eventTime":`Duração do evento: 16 de outubro de 2024, 00:00 - 29 de outubro de 2024, 23:59 (UTC)`,"canChangeRole":true,"title":`O Parque das Marionetes`,"infoContent":``,"showRulePopup":false},"it-IT":{"eventTime":`Durata dell'Evento: 16 ottobre 2024, 00:00 - 29 ottobre 2024, 23:59 (UTC)`,"canChangeRole":true,"title":`Il Parco delle Marionette`,"infoContent":``,"showRulePopup":false},"tr-TR":{"eventTime":`Etkinlik Süresi: 16 Ekim 2024, 00.00 - 29 Ekim 2024, 23.59 (UTC)`,"canChangeRole":true,"title":`Kukla Parkı`,"infoContent":``,"showRulePopup":false},"pl-PL":{"eventTime":`Czas trwania wydarzenia: 16 października 2024, 00:00 - 29 października 2024, 23:59 (UTC)`,"canChangeRole":true,"title":`Park Marionetek`,"infoContent":``,"showRulePopup":false},"id-ID":{"eventTime":`Waktu Event: 16/10/2024 00:00 - 29/10/2024 23:59 (UTC)`,"canChangeRole":true,"title":`Horor Park`,"infoContent":``,"showRulePopup":false},"ar-SA":{"eventTime":`وقت الحدث: 16 أكتوبر 2024 الساعة 0:00 - 29 أكتوبر 2024 الساعة 23:59 (بالتوقيت العالمي المنسق)`,"canChangeRole":true,"title":`حديقة الرعب`,"infoContent":``,"showRulePopup":false}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '首页';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})
const initActivity = inject("initActivity", () => {})
const curPlatform = utils.getMainHost() == "gm99.com" ? "gm99" : "global";
const canClickRefresh = inject("canClickRefresh", true);
const canClickChange = ref(true);
compData.showRulePopup = false;
watch(
  () => pageData.ruleConfig,
  (val) => {
    if (val) {
      const conditionMap = {
        level_limit: langData.roleLevel,
        new_register_before_activity: langData.activityBefore,
        loss_limit: "",
      };
      if (!compData.infoContent.length && val) {
        let rule = ``;
        Object.keys(val).forEach((key, index) => {
          rule += `${index + 1}、${
                key == "captain" ? langData.captainLimit : langData.memberLimit
              }<br>`;
          if (!val[key] || val[key].length == 0) {
            rule += `${langData.noLimit}<br>`;
          }
          if (val[key]) {
            val[key].forEach((item, subIndex) => {
              rule += `(${subIndex + 1})${conditionMap[
                    item.condition
                  ].replace("${num}", item.limit)}<br>`;
            });
          }
        });
        compData.infoContent = langData.ruleDetail.replace(
          "${rule}",
          rule
        );
        compData.infoContent = compData.infoContent.replace(/\\n/g, "<br>");
      }
    }
  }
);;
      // 活动规则的click事件
      const u_c_H66R28_event_O1F141= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "活动规则",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
pageData.infoPopupState = true} catch (error) {console.log(error)}
      };
      // 活动规则弹窗的click事件
      const u_c_RNJC316_event_TETB35= async (e)=>{
        try {pageData.infoPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_CW0J317_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_CU7D321_event_DMX517= async (e)=>{
        try {pageData.infoPopupState = false} catch (error) {console.log(error)}
      };
      // 背包的click事件
      const u_c_9GJF30_event_5ZWY20= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "背包",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 刷新的click事件
      const u_c_4Z6O38_event_YVD624= async (e)=>{
        try {if (!checkIsLogin()) return
if (!checkIsBind()) return
if(!canClickRefresh.value)return;
canClickRefresh.value = false;
initActivity();
await utils.sleep(5);
canClickRefresh.value = true;} catch (error) {console.log(error)}
      };
      // 登入按钮的click事件
      const u_c_LKGL33_event_Q72S64= async (e)=>{
        try {checkIsLogin()} catch (error) {console.log(error)}
      };
      // 绑定按钮的click事件
      const u_c_VH2A39_event_Z75334= async (e)=>{
        try {if (!checkIsLogin()) return
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "绑定按钮",
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
pageData.bindPopupState = true;} catch (error) {console.log(error)}
      };
      // 解绑按钮的click事件
      const u_c_M24U41_event_Z75334= async (e)=>{
        try {if(!canClickChange.value)return;
// if(+pageData.curTeamSize) {
//   showTips(langData.resetRoleDeny);
//   return;
// }
canClickChange.value = false;

const link = {
  gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=unbindRole`,
  global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=unbindRole`,
}
let res = await request.getJSON(link[curPlatform])
canClickChange.value = true;

if(res.result!=1){
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  return;
}

pageData.isBind = false;
pageData.roleName ="";
pageData.serverName = "";
} catch (error) {console.log(error)}
      };
      // 背包按钮的click事件
      const u_c_4IL543_event_4DJR33= async (e)=>{
        try {pageData.bagPopupState = true} catch (error) {console.log(error)}
      };
      // 登出按钮的click事件
      const u_c_4CEU45_event_Q72S64= async (e)=>{
        try {let link = {
  gm99: `https://passport.gm99.com/login/logout2`,
  global: `https://gpassport.${utils.getMainHost()}/web_login/logout`,
}
let res = await request.getJSON(link[curPlatform])
if (res.result == 1) {
  window.location.reload()
}} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.default{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.default{
.u_c_RNJC316.normal{
position:relative;

}
}.default{
.u_c_CW0J317.normal{
position:relative;

}
}.default{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.default{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.default{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.default{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.default{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.default{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.default{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.default{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.default{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.default{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.default{
.u_c_1KC128.normal{
position:relative;

}
}.default{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.default{
.u_c_YF2K30.normal{
position:relative;

}
}.default{
.u_c_M12A31.normal{
position:relative;

}
}.default{
.u_c_LKGL33.normal{
position:relative;

}
}.default{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.default{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.default{
.u_c_VH2A39.normal{
position:relative;

}
}.default{
.u_c_M24U41.normal{
position:relative;

}
}.default{
.u_c_4IL543.normal{
position:relative;

}
}.default{
.u_c_4CEU45.normal{
position:relative;

}
}.zh-CN{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.zh-CN{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.zh-CN{
.u_c_RNJC316.normal{
position:relative;

}
}.zh-CN{
.u_c_CW0J317.normal{
position:relative;

}
}.zh-CN{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.zh-CN{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.zh-CN{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.zh-CN{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.zh-CN{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.zh-CN{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.zh-CN{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.zh-CN{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.zh-CN{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.zh-CN{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.zh-CN{
.u_c_1KC128.normal{
position:relative;

}
}.zh-CN{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.zh-CN{
.u_c_YF2K30.normal{
position:relative;

}
}.zh-CN{
.u_c_M12A31.normal{
position:relative;

}
}.zh-CN{
.u_c_LKGL33.normal{
position:relative;

}
}.zh-CN{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.zh-CN{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.zh-CN{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.zh-CN{
.u_c_VH2A39.normal{
position:relative;

}
}.zh-CN{
.u_c_M24U41.normal{
position:relative;

}
}.zh-CN{
.u_c_4IL543.normal{
position:relative;

}
}.zh-CN{
.u_c_4CEU45.normal{
position:relative;

}
}.zh-TW{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.zh-TW{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.zh-TW{
.u_c_RNJC316.normal{
position:relative;

}
}.zh-TW{
.u_c_CW0J317.normal{
position:relative;

}
}.zh-TW{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.zh-TW{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.zh-TW{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.zh-TW{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.zh-TW{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.zh-TW{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.zh-TW{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.zh-TW{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.zh-TW{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.zh-TW{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.zh-TW{
.u_c_1KC128.normal{
position:relative;

}
}.zh-TW{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.zh-TW{
.u_c_YF2K30.normal{
position:relative;

}
}.zh-TW{
.u_c_M12A31.normal{
position:relative;

}
}.zh-TW{
.u_c_LKGL33.normal{
position:relative;

}
}.zh-TW{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.zh-TW{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.zh-TW{
.u_c_VH2A39.normal{
position:relative;

}
}.zh-TW{
.u_c_M24U41.normal{
position:relative;

}
}.zh-TW{
.u_c_4IL543.normal{
position:relative;

}
}.zh-TW{
.u_c_4CEU45.normal{
position:relative;

}
}.en-US{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.en-US{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.en-US{
.u_c_RNJC316.normal{
position:relative;

}
}.en-US{
.u_c_CW0J317.normal{
position:relative;

}
}.en-US{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.en-US{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.en-US{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.en-US{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.en-US{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.en-US{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.en-US{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.en-US{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.en-US{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.en-US{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.en-US{
.u_c_1KC128.normal{
position:relative;

}
}.en-US{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.en-US{
.u_c_YF2K30.normal{
position:relative;

}
}.en-US{
.u_c_M12A31.normal{
position:relative;

}
}.en-US{
.u_c_LKGL33.normal{
position:relative;

}
}.en-US{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.en-US{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.en-US{
.u_c_VH2A39.normal{
position:relative;

}
}.en-US{
.u_c_M24U41.normal{
position:relative;

}
}.en-US{
.u_c_4IL543.normal{
position:relative;

}
}.en-US{
.u_c_4CEU45.normal{
position:relative;

}
}.ja-JP{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.ja-JP{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.ja-JP{
.u_c_RNJC316.normal{
position:relative;

}
}.ja-JP{
.u_c_CW0J317.normal{
position:relative;

}
}.ja-JP{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.ja-JP{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.ja-JP{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.ja-JP{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.ja-JP{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.ja-JP{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.ja-JP{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.ja-JP{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.ja-JP{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.ja-JP{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ja-JP{
.u_c_1KC128.normal{
position:relative;

}
}.ja-JP{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.ja-JP{
.u_c_YF2K30.normal{
position:relative;

}
}.ja-JP{
.u_c_M12A31.normal{
position:relative;

}
}.ja-JP{
.u_c_LKGL33.normal{
position:relative;

}
}.ja-JP{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ja-JP{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.ja-JP{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.ja-JP{
.u_c_VH2A39.normal{
position:relative;

}
}.ja-JP{
.u_c_M24U41.normal{
position:relative;

}
}.ja-JP{
.u_c_4IL543.normal{
position:relative;

}
}.ja-JP{
.u_c_4CEU45.normal{
position:relative;

}
}.ko-KR{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.ko-KR{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.ko-KR{
.u_c_RNJC316.normal{
position:relative;

}
}.ko-KR{
.u_c_CW0J317.normal{
position:relative;

}
}.ko-KR{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.ko-KR{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.ko-KR{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.ko-KR{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.ko-KR{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.ko-KR{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.ko-KR{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.ko-KR{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.ko-KR{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.ko-KR{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ko-KR{
.u_c_1KC128.normal{
position:relative;

}
}.ko-KR{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.ko-KR{
.u_c_YF2K30.normal{
position:relative;

}
}.ko-KR{
.u_c_M12A31.normal{
position:relative;

}
}.ko-KR{
.u_c_LKGL33.normal{
position:relative;

}
}.ko-KR{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ko-KR{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.ko-KR{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.ko-KR{
.u_c_VH2A39.normal{
position:relative;

}
}.ko-KR{
.u_c_M24U41.normal{
position:relative;

}
}.ko-KR{
.u_c_4IL543.normal{
position:relative;

}
}.ko-KR{
.u_c_4CEU45.normal{
position:relative;

}
}.th-TH{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.th-TH{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.th-TH{
.u_c_RNJC316.normal{
position:relative;

}
}.th-TH{
.u_c_CW0J317.normal{
position:relative;

}
}.th-TH{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.th-TH{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.th-TH{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.th-TH{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.th-TH{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.th-TH{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.th-TH{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.th-TH{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.th-TH{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.th-TH{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.th-TH{
.u_c_1KC128.normal{
position:relative;

}
}.th-TH{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.th-TH{
.u_c_YF2K30.normal{
position:relative;

}
}.th-TH{
.u_c_M12A31.normal{
position:relative;

}
}.th-TH{
.u_c_LKGL33.normal{
position:relative;

}
}.th-TH{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.th-TH{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.th-TH{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.th-TH{
.u_c_VH2A39.normal{
position:relative;

}
}.th-TH{
.u_c_M24U41.normal{
position:relative;

}
}.th-TH{
.u_c_4IL543.normal{
position:relative;

}
}.th-TH{
.u_c_4CEU45.normal{
position:relative;

}
}.vi-VN{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.vi-VN{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.vi-VN{
.u_c_RNJC316.normal{
position:relative;

}
}.vi-VN{
.u_c_CW0J317.normal{
position:relative;

}
}.vi-VN{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.vi-VN{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.vi-VN{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.vi-VN{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.vi-VN{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.vi-VN{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.vi-VN{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.vi-VN{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.vi-VN{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.vi-VN{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.vi-VN{
.u_c_1KC128.normal{
position:relative;

}
}.vi-VN{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.vi-VN{
.u_c_YF2K30.normal{
position:relative;

}
}.vi-VN{
.u_c_M12A31.normal{
position:relative;

}
}.vi-VN{
.u_c_LKGL33.normal{
position:relative;

}
}.vi-VN{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.vi-VN{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.vi-VN{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.vi-VN{
.u_c_VH2A39.normal{
position:relative;

}
}.vi-VN{
.u_c_M24U41.normal{
position:relative;

}
}.vi-VN{
.u_c_4IL543.normal{
position:relative;

}
}.vi-VN{
.u_c_4CEU45.normal{
position:relative;

}
}.de-DE{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.de-DE{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.de-DE{
.u_c_RNJC316.normal{
position:relative;

}
}.de-DE{
.u_c_CW0J317.normal{
position:relative;

}
}.de-DE{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.de-DE{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.de-DE{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.de-DE{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.de-DE{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.de-DE{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.de-DE{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.de-DE{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.de-DE{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.de-DE{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.de-DE{
.u_c_1KC128.normal{
position:relative;

}
}.de-DE{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.de-DE{
.u_c_YF2K30.normal{
position:relative;

}
}.de-DE{
.u_c_M12A31.normal{
position:relative;

}
}.de-DE{
.u_c_LKGL33.normal{
position:relative;

}
}.de-DE{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.de-DE{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.de-DE{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.de-DE{
.u_c_VH2A39.normal{
position:relative;

}
}.de-DE{
.u_c_M24U41.normal{
position:relative;

}
}.de-DE{
.u_c_4IL543.normal{
position:relative;

}
}.de-DE{
.u_c_4CEU45.normal{
position:relative;

}
}.fr-FR{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.fr-FR{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.fr-FR{
.u_c_RNJC316.normal{
position:relative;

}
}.fr-FR{
.u_c_CW0J317.normal{
position:relative;

}
}.fr-FR{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.fr-FR{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.fr-FR{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.fr-FR{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.fr-FR{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.fr-FR{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.fr-FR{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.fr-FR{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.fr-FR{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.fr-FR{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.fr-FR{
.u_c_1KC128.normal{
position:relative;

}
}.fr-FR{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.fr-FR{
.u_c_YF2K30.normal{
position:relative;

}
}.fr-FR{
.u_c_M12A31.normal{
position:relative;

}
}.fr-FR{
.u_c_LKGL33.normal{
position:relative;

}
}.fr-FR{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.fr-FR{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.fr-FR{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.fr-FR{
.u_c_VH2A39.normal{
position:relative;

}
}.fr-FR{
.u_c_M24U41.normal{
position:relative;

}
}.fr-FR{
.u_c_4IL543.normal{
position:relative;

}
}.fr-FR{
.u_c_4CEU45.normal{
position:relative;

}
}.ru-RU{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.ru-RU{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.ru-RU{
.u_c_RNJC316.normal{
position:relative;

}
}.ru-RU{
.u_c_CW0J317.normal{
position:relative;

}
}.ru-RU{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.ru-RU{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.ru-RU{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.ru-RU{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.ru-RU{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.ru-RU{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.ru-RU{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.ru-RU{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.ru-RU{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.ru-RU{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ru-RU{
.u_c_1KC128.normal{
position:relative;

}
}.ru-RU{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.ru-RU{
.u_c_YF2K30.normal{
position:relative;

}
}.ru-RU{
.u_c_M12A31.normal{
position:relative;

}
}.ru-RU{
.u_c_LKGL33.normal{
position:relative;

}
}.ru-RU{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ru-RU{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.ru-RU{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.ru-RU{
.u_c_VH2A39.normal{
position:relative;

}
}.ru-RU{
.u_c_M24U41.normal{
position:relative;

}
}.ru-RU{
.u_c_4IL543.normal{
position:relative;

}
}.ru-RU{
.u_c_4CEU45.normal{
position:relative;

}
}.es-ES{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.es-ES{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.es-ES{
.u_c_RNJC316.normal{
position:relative;

}
}.es-ES{
.u_c_CW0J317.normal{
position:relative;

}
}.es-ES{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.es-ES{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.es-ES{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.es-ES{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.es-ES{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.es-ES{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.es-ES{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.es-ES{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.es-ES{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.es-ES{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.es-ES{
.u_c_1KC128.normal{
position:relative;

}
}.es-ES{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.es-ES{
.u_c_YF2K30.normal{
position:relative;

}
}.es-ES{
.u_c_M12A31.normal{
position:relative;

}
}.es-ES{
.u_c_LKGL33.normal{
position:relative;

}
}.es-ES{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.es-ES{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.es-ES{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.es-ES{
.u_c_VH2A39.normal{
position:relative;

}
}.es-ES{
.u_c_M24U41.normal{
position:relative;

}
}.es-ES{
.u_c_4IL543.normal{
position:relative;

}
}.es-ES{
.u_c_4CEU45.normal{
position:relative;

}
}.pt-PT{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.pt-PT{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.pt-PT{
.u_c_RNJC316.normal{
position:relative;

}
}.pt-PT{
.u_c_CW0J317.normal{
position:relative;

}
}.pt-PT{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.pt-PT{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.pt-PT{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.pt-PT{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.pt-PT{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.pt-PT{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.pt-PT{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.pt-PT{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.pt-PT{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.pt-PT{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.pt-PT{
.u_c_1KC128.normal{
position:relative;

}
}.pt-PT{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.pt-PT{
.u_c_YF2K30.normal{
position:relative;

}
}.pt-PT{
.u_c_M12A31.normal{
position:relative;

}
}.pt-PT{
.u_c_LKGL33.normal{
position:relative;

}
}.pt-PT{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.pt-PT{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.pt-PT{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.pt-PT{
.u_c_VH2A39.normal{
position:relative;

}
}.pt-PT{
.u_c_M24U41.normal{
position:relative;

}
}.pt-PT{
.u_c_4IL543.normal{
position:relative;

}
}.pt-PT{
.u_c_4CEU45.normal{
position:relative;

}
}.it-IT{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.it-IT{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.it-IT{
.u_c_RNJC316.normal{
position:relative;

}
}.it-IT{
.u_c_CW0J317.normal{
position:relative;

}
}.it-IT{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.it-IT{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.it-IT{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.it-IT{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.it-IT{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.it-IT{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.it-IT{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.it-IT{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.it-IT{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.it-IT{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.it-IT{
.u_c_1KC128.normal{
position:relative;

}
}.it-IT{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.it-IT{
.u_c_YF2K30.normal{
position:relative;

}
}.it-IT{
.u_c_M12A31.normal{
position:relative;

}
}.it-IT{
.u_c_LKGL33.normal{
position:relative;

}
}.it-IT{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.it-IT{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.it-IT{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.it-IT{
.u_c_VH2A39.normal{
position:relative;

}
}.it-IT{
.u_c_M24U41.normal{
position:relative;

}
}.it-IT{
.u_c_4IL543.normal{
position:relative;

}
}.it-IT{
.u_c_4CEU45.normal{
position:relative;

}
}.tr-TR{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.tr-TR{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.tr-TR{
.u_c_RNJC316.normal{
position:relative;

}
}.tr-TR{
.u_c_CW0J317.normal{
position:relative;

}
}.tr-TR{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.tr-TR{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.tr-TR{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.tr-TR{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.tr-TR{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.tr-TR{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.tr-TR{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.tr-TR{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.tr-TR{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.tr-TR{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.tr-TR{
.u_c_1KC128.normal{
position:relative;

}
}.tr-TR{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.tr-TR{
.u_c_YF2K30.normal{
position:relative;

}
}.tr-TR{
.u_c_M12A31.normal{
position:relative;

}
}.tr-TR{
.u_c_LKGL33.normal{
position:relative;

}
}.tr-TR{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.tr-TR{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.tr-TR{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.tr-TR{
.u_c_VH2A39.normal{
position:relative;

}
}.tr-TR{
.u_c_M24U41.normal{
position:relative;

}
}.tr-TR{
.u_c_4IL543.normal{
position:relative;

}
}.tr-TR{
.u_c_4CEU45.normal{
position:relative;

}
}.pl-PL{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.pl-PL{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.pl-PL{
.u_c_RNJC316.normal{
position:relative;

}
}.pl-PL{
.u_c_CW0J317.normal{
position:relative;

}
}.pl-PL{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.pl-PL{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.pl-PL{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.pl-PL{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.pl-PL{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.pl-PL{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.pl-PL{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.pl-PL{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.pl-PL{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.pl-PL{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.pl-PL{
.u_c_1KC128.normal{
position:relative;

}
}.pl-PL{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.pl-PL{
.u_c_YF2K30.normal{
position:relative;

}
}.pl-PL{
.u_c_M12A31.normal{
position:relative;

}
}.pl-PL{
.u_c_LKGL33.normal{
position:relative;

}
}.pl-PL{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.pl-PL{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.pl-PL{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.pl-PL{
.u_c_VH2A39.normal{
position:relative;

}
}.pl-PL{
.u_c_M24U41.normal{
position:relative;

}
}.pl-PL{
.u_c_4IL543.normal{
position:relative;

}
}.pl-PL{
.u_c_4CEU45.normal{
position:relative;

}
}.id-ID{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.id-ID{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.id-ID{
.u_c_RNJC316.normal{
position:relative;

}
}.id-ID{
.u_c_CW0J317.normal{
position:relative;

}
}.id-ID{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.id-ID{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.id-ID{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.id-ID{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.id-ID{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.id-ID{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.id-ID{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.id-ID{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.id-ID{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.id-ID{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.id-ID{
.u_c_1KC128.normal{
position:relative;

}
}.id-ID{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.id-ID{
.u_c_YF2K30.normal{
position:relative;

}
}.id-ID{
.u_c_M12A31.normal{
position:relative;

}
}.id-ID{
.u_c_LKGL33.normal{
position:relative;

}
}.id-ID{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.id-ID{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.id-ID{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.id-ID{
.u_c_VH2A39.normal{
position:relative;

}
}.id-ID{
.u_c_M24U41.normal{
position:relative;

}
}.id-ID{
.u_c_4IL543.normal{
position:relative;

}
}.id-ID{
.u_c_4CEU45.normal{
position:relative;

}
}.ar-SA{
.u_c_QXLF22.normal{
position:relative;
width:10.00rem;
height:auto;
background:no-repeat center;
background-size:cover;
overflow:hidden;
margin:auto;
font-size:0;
padding-bottom:1.07rem;

}

.u_c_QXLF22.normal .btn-bg{
width:1.85rem;
height:0.67rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712733749169-58.png);
background-size:100% 100%;

}

.u_c_QXLF22.normal .btn-text{
font-size:0.27rem;
color:#fff;

}
}.ar-SA{
.u_c_H66R28.normal{
position:absolute;
background:no-repeat center;
display:flex;
justify-content:center;
align-items:center;
color:#ffffff;
font-size:0.24rem;
right:0!important;
top:0.37rem;
background-size:100% 100%;
z-index:11;
cursor:pointer;
background-color:#25465b;
width:1.84rem;
height:0.68rem;
box-sizing:border-box;
padding:0.07rem;
text-align:center;

}
}.ar-SA{
.u_c_RNJC316.normal{
position:relative;

}
}.ar-SA{
.u_c_CW0J317.normal{
position:relative;

}
}.ar-SA{
.u_c_GLI0318.normal{
position:relative;
margin-top:-0.15rem;

}
}.ar-SA{
.u_c_KANB320.normal{
position:relative;
box-sizing:border-box;
height:6.80rem;
overflow-y:auto;
margin-top:0.31rem;
white-space:pre-wrap;
line-height:1.5;
text-align:left;

}
}.ar-SA{
.u_c_CU7D321.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.ar-SA{
.u_c_9GJF30.normal{
position:absolute;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.20rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.ar-SA{
.u_c_4Z6O38.normal{
position:absolute;
background:no-repeat center;
display:none;
justify-content:center;
align-items:center;
color:#fff;
font-size:0.27rem;
right:0!important;
top:1.93rem;
background-size:100% 100%;
z-index:10;
cursor:pointer;

}
}.ar-SA{
.u_c_1NR525.normal{
position:absolute;
width:2.53rem;
height:0.93rem;
top:0.40rem;
right:7.05rem;
background:no-repeat center;
background-size:contain;

}
}.ar-SA{
.u_c_I7WN40.normal{
position:relative;
margin-top:7.15rem;
width:10.00rem;
height:fit-content;
font-size:0.73rem;
text-align:center;
font-weight:bold;
line-height:1.1;
z-index:1;

}
}.ar-SA{
.u_c_DNI241.normal{
position:absolute;
width:100%;
cursor:auto;
color:transparent;

}
}.ar-SA{
.u_c_KL7K42.normal{
position:relative;
-webkit-background-clip:text;
background-clip:text;
cursor:auto;
color:transparent;

}
}.ar-SA{
.u_c_VYPR27.normal{
position:relative;
width:100%;
height:auto;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.61rem;
display:flex;
justify-content:center;
align-items:center;
line-height:1.2;
font-size:0.28rem;
color:#fff;
white-space:pre-wrap;
text-align:center;
font-weight:normal;

}
}.ar-SA{
.u_c_1KC128.normal{
position:relative;

}
}.ar-SA{
.u_c_40PV29.normal{
position:relative;
margin:auto;
margin-top:0.17rem;
font-size:0;
box-sizing:border-box;
text-align:center;

}

.u_c_40PV29.normal .login-box{
display:flex;
justify-content:center;
align-items:center;

}

.u_c_40PV29.normal .txt{
font-size:0.29rem;

}

.u_c_40PV29.normal .btn{
margin:auto 0.13rem;

}
}.ar-SA{
.u_c_YF2K30.normal{
position:relative;

}
}.ar-SA{
.u_c_M12A31.normal{
position:relative;

}
}.ar-SA{
.u_c_LKGL33.normal{
position:relative;

}
}.ar-SA{
.u_c_L32Y35.normal{
position:relative;
display:flex;
flex-flow:wrap;

}
}.ar-SA{
.u_c_1DP336.normal{
position:relative;
white-space:nowrap;

}
}.ar-SA{
.u_c_P9TD38.normal{
position:relative;
white-space:nowrap;

}
}.ar-SA{
.u_c_VH2A39.normal{
position:relative;

}
}.ar-SA{
.u_c_M24U41.normal{
position:relative;

}
}.ar-SA{
.u_c_4IL543.normal{
position:relative;

}
}.ar-SA{
.u_c_4CEU45.normal{
position:relative;

}
}
</style>
